/***
 * @file:éç¨äºangularçè¡¨åéªè¯è§å
 * @author: linkun.he
 * @Date: 2019-06-03 10:11:13
 */
import {
  ÉµisObservable as isObservable,
  ÉµisPromise as isPromise
} from "@angular/core";
import {
  AbstractControl,
  AsyncValidatorFn,
  ValidationErrors,
  ValidatorFn
} from "@angular/forms";
import { forkJoin, from, Observable } from "rxjs";
import { map } from "rxjs/operators";

import {
  isAllCharacter,
  isBlank,
  isChinese,
  isComma,
  isdateline,
  isDecimal,
  isDigits,
  isDomain,
  isEmail,
  isEmptyInputValue,
  isExtraction,
  isFigures,
  isIdCard,
  isInt,
  isIpRe,
  isLanguage,
  isLegality,
  isLetters,
  isMobile,
  isNoLanguage,
  isNum,
  isPostal,
  isShort,
  isSize,
  isSpecialCharacter,
  isStrongCipher,
  isTencent,
  isTeplphone,
  isTwoDecimal,
  isUrl,
  isWebRe
} from "./validate";

/** éªè¯å¨ */
// @dynamic
export class DtValidators {
  //  angularèªå¸¦çéªè¯è§åstart
  /** æ¯å¦å¿å¡« */
  static required(control: AbstractControl): ValidationErrors | null {
    return isEmptyInputValue(control.value) ? { required: true } : null;
  }

  /** æå°å¼ */
  static min(min: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (isEmptyInputValue(control.value) || isEmptyInputValue(min)) {
        return null;
      }
      const value = parseFloat(control.value);
      // Controls with NaN values after parsing should be treated as not having a
      // minimum, per the HTML forms spec: https://www.w3.org/TR/html5/forms.html#attr-input-min
      return !isNaN(value) && value < min
        ? { min: { min, actual: control.value } }
        : null;
    };
  }

  /** æå¤§å¼ */
  static max(max: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (isEmptyInputValue(control.value) || isEmptyInputValue(max)) {
        return null;
      }
      const value = parseFloat(control.value);
      return !isNaN(value) && value > max
        ? { max: { max, actual: control.value } }
        : null;
    };
  }

  /** æå°é¿åº¦ */
  static minLength(minLength: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (isEmptyInputValue(control.value)) {
        return null;
      }
      const length: number = control.value ? control.value.length : 0;
      return length < minLength
        ? { minlength: { requiredLength: minLength, actualLength: length } }
        : null;
    };
  }

  /** æå¤§é¿åº¦ */
  static maxLength(maxLength: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const length: number = control.value ? control.value.length : 0;
      return length > maxLength
        ? { maxlength: { requiredLength: maxLength, actualLength: length } }
        : null;
    };
  }

  /** éªè¯æ¯å¦ä¸ºtrueï¼å¸¸è§äºå¤éæ¡éªè¯ */
  static requiredTrue(control: AbstractControl): ValidationErrors | null {
    return control.value === true ? null : { required: true };
  }

  /** é®ç®± */
  static email(control: AbstractControl): ValidationErrors | null {
    if (isEmptyInputValue(control.value)) {
      return null;
    }
    return isEmail(control.value) ? null : { email: true };
  }

  static pattern(pattern: string | RegExp): ValidatorFn {
    if (!pattern) {
      return DtValidators.nullValidator;
    }
    let regex: RegExp;
    let regexStr: string;
    if (typeof pattern === "string") {
      regexStr = "";
      if (pattern.charAt(0) !== "^") {
        regexStr += "^";
      }
      regexStr += pattern;
      if (pattern.charAt(pattern.length - 1) !== "$") {
        regexStr += "$";
      }
      regex = new RegExp(regexStr);
    } else {
      regexStr = pattern.toString();
      regex = pattern;
    }
    return (control: AbstractControl): ValidationErrors | null => {
      if (isEmptyInputValue(control.value)) {
        return null; // don't validate empty values to allow optional controls
      }
      const value: string = control.value;
      return regex.test(value)
        ? null
        : { pattern: { requiredPattern: regexStr, actualValue: value } };
    };
  }

  /**
   * @description
   * Validator that performs no operation.
   */
  static nullValidator(control: AbstractControl): ValidationErrors | null {
    return null;
  }

  /**
   * @description
   * Compose multiple validators into a single function that returns the union
   * of the individual error maps for the provided control.
   *
   * @returns A validator function that returns an error map with the
   * merged error maps of the validators if the validation check fails, otherwise `null`.
   */
  static compose(validators: null): null;
  static compose(
    validators: (ValidatorFn | null | undefined)[]
  ): ValidatorFn | null;
  static compose(
    validators: (ValidatorFn | null | undefined)[] | null
  ): ValidatorFn | null {
    if (!validators) {
      return null;
    }
    const presentValidators: ValidatorFn[] = validators.filter(
      isPresent
    ) as any;
    if (presentValidators.length === 0) {
      return null;
    }

    return (control: AbstractControl) => {
      return _mergeErrors(_executeValidators(control, presentValidators));
    };
  }

  /**
   * @description
   * Compose multiple async validators into a single function that returns the union
   * of the individual error objects for the provided control.
   *
   * @returns A validator function that returns an error map with the
   * merged error objects of the async validators if the validation check fails, otherwise `null`.
   */
  static composeAsync(
    validators: (AsyncValidatorFn | null)[]
  ): AsyncValidatorFn | null {
    if (!validators) {
      return null;
    }
    const presentValidators: AsyncValidatorFn[] = validators.filter(
      isPresent
    ) as any;
    if (presentValidators.length === 0) {
      return null;
    }

    return (control: AbstractControl) => {
      const observables = _executeAsyncValidators(
        control,
        presentValidators
      ).map(toObservable);
      return forkJoin(observables).pipe(map(_mergeErrors));
    };
  }

  // angularèªå¸¦çéªè¯è§å end

  /** æ¯å¦ä¸ºæ°å­ */
  static num(control: AbstractControl): ValidationErrors | null {
    if (isEmptyInputValue(control.value)) {
      return null; // don't validate empty values to allow optional controls
    }
    return isNum(control.value) ? null : { num: true };
  }

  /** æ¯å¦ä¸ºæ´æ° */
  static int(control: AbstractControl): ValidationErrors | null {
    if (isEmptyInputValue(control.value)) {
      return null;
    }
    return control.value && isInt(control.value) ? null : { int: true };
  }

  /** æ¯å¦ä¸ºå°æ° */
  static decimal(control: AbstractControl): ValidationErrors | null {
    if (isEmptyInputValue(control.value)) {
      return null;
    }
    return control.value && isDecimal(control.value) ? null : { decimal: true };
  }

  /** æ¯å¦ä¸ºèº«ä»½è¯ */
  static idCard(control: AbstractControl): ValidationErrors | null {
    if (isEmptyInputValue(control.value)) {
      return null;
    }
    return isIdCard(control.value) ? null : { idCard: true };
  }

  /** æ¯å¦ä¸ºææºå· */
  static mobile(control: AbstractControl): ValidationErrors | null {
    if (isEmptyInputValue(control.value)) {
      return null;
    }
    return isMobile(control.value) ? null : { mobile: true };
  }

  /** æ¯å¦URLå°å */
  static url(control: AbstractControl): ValidationErrors | null {
    if (isEmptyInputValue(control.value)) {
      return null;
    }
    return isUrl(control.value) ? null : { url: true };
  }

  /** éé¶å¼å¤´çæå¤å¸¦ä¸¤ä½å°æ°çæ°å­ */
  static twoDecimal(control: AbstractControl): ValidationErrors | null {
    if (isEmptyInputValue(control.value)) {
      return null;
    }
    return isTwoDecimal(control.value) ? null : { twoDecimal: true };
  }

  /** ä¸­æãè±æãæ°å­åæ¬ä¸åçº¿ï¼ */
  static language(control: AbstractControl): ValidationErrors | null {
    if (isEmptyInputValue(control.value)) {
      return null;
    }
    return isLanguage(control.value) ? null : { language: true };
  }

  /** ä¸­æãè±æãæ°å­ä½ä¸åæ¬ä¸åçº¿ç­ç¬¦å· */
  static noLanguage(control: AbstractControl): ValidationErrors | null {
    if (isEmptyInputValue(control.value)) {
      return null;
    }
    return isNoLanguage(control.value) ? null : { noLanguage: true };
  }

  /** è±æåæ°å­ï¼^[A-Za-z0-9]+$ æ ^[A-Za-z0-9]{4,40}$  */
  static figures(control: AbstractControl): ValidationErrors | null {
    if (isEmptyInputValue(control.value)) {
      return null;
    }
    return isFigures(control.value) ? null : { figures: true };
  }

  /** åå */
  static domain(control: AbstractControl): ValidationErrors | null {
    if (isEmptyInputValue(control.value)) {
      return null;
    }
    return isDomain(control.value) ? null : { domain: true };
  }

  /** å½åçµè¯å·ç  */
  static teplphone(control: AbstractControl): ValidationErrors | null {
    if (isEmptyInputValue(control.value)) {
      return null;
    }
    return isTeplphone(control.value) ? null : { teplphone: true };
  }

  /** ç­èº«ä»½è¯å·ç (æ°å­ãå­æ¯xç»å°¾) */
  static short(control: AbstractControl): ValidationErrors | null {
    if (isEmptyInputValue(control.value)) {
      return null;
    }
    return isShort(control.value) ? null : { short: true };
  }

  /** å¸å·æ¯å¦åæ³(å­æ¯å¼å¤´ï¼åè®¸5-16å­èï¼åè®¸å­æ¯æ°å­ä¸åçº¿) */
  static legality(control: AbstractControl): ValidationErrors | null {
    if (isEmptyInputValue(control.value)) {
      return null;
    }
    return isLegality(control.value) ? null : { legality: true };
  }

  /** å¼ºå¯ç (å¿é¡»åå«å¤§å°åå­æ¯åæ°å­çç»åï¼ä¸è½ä½¿ç¨ç¹æ®å­ç¬¦ï¼é¿åº¦å¨8-10ä¹é´) */
  static strongCipher(control: AbstractControl): ValidationErrors | null {
    if (isEmptyInputValue(control.value)) {
      return null;
    }
    return isStrongCipher(control.value) ? null : { strongCipher: true };
  }

  /** ç¹æ®å­ç¬¦ */
  static specialCharacter(control: AbstractControl): ValidationErrors | null {
    if (isEmptyInputValue(control.value)) {
      return null;
    }
    return isSpecialCharacter(control.value)
      ? null
      : { specialCharacter: true };
  }

  /** ä¸­å½é®æ¿ç¼ç ï¼[1-9]\d{5}(?!\d) (ä¸­å½é®æ¿ç¼ç ä¸º6ä½æ°å­) */
  static postal(control: AbstractControl): ValidationErrors | null {
    if (isEmptyInputValue(control.value)) {
      return null;
    }
    return isPostal(control.value) ? null : { postal: true };
  }

  /** æåColor Hex  Codes */
  static extraction(control: AbstractControl): ValidationErrors | null {
    if (isEmptyInputValue(control.value)) {
      return null;
    }
    return isExtraction(control.value) ? null : { extraction: true };
  }

  /** é¿åº¦ä¸º3-20çææå­ç¬¦ */
  static allCharacter(control: AbstractControl): ValidationErrors | null {
    if (isEmptyInputValue(control.value)) {
      return null;
    }
    return isAllCharacter(control.value) ? null : { allCharacter: true };
  }

  /**  5-18ä½çæ°å­ï¼ */
  static digits(control: AbstractControl): ValidationErrors | null {
    if (isEmptyInputValue(control.value)) {
      return null;
    }
    return isDigits(control.value) ? null : { digits: true };
  }

  /** ä¸ºæ±å­ */
  static chinese(control: AbstractControl): ValidationErrors | null {
    if (isEmptyInputValue(control.value)) {
      return null;
    }
    return isChinese(control.value) ? null : { chinese: true };
  }

  /** ç±26ä¸ªè±æå­æ¯ç»æçå­ç¬¦ä¸² */
  static letters(control: AbstractControl): ValidationErrors | null {
    if (isEmptyInputValue(control.value)) {
      return null;
    }
    return isLetters(control.value) ? null : { letters: true };
  }

  /** è¾è®¯QQå· */
  static tencent(control: AbstractControl): ValidationErrors | null {
    if (isEmptyInputValue(control.value)) {
      return null;
    }
    return isTencent(control.value) ? null : { tencent: true };
  }

  /** æ°å­å¨15-200ä¹é´ */
  static size(control: AbstractControl): ValidationErrors | null {
    if (isEmptyInputValue(control.value)) {
      return null;
    }
    return isSize(control.value) ? null : { size: true };
  }

  /** é¦å°¾ç©ºç½å­ç¬¦çæ­£åè¡¨è¾¾å¼ */
  static blank(control: AbstractControl): ValidationErrors | null {
    if (isEmptyInputValue(control.value)) {
      return null;
    }
    return isBlank(control.value) ? null : { blank: true };
  }

  /** éªè¯è´§å¸å¯ä»¥å¸¦éå·æèä¸ºå¸¦åç¬¦å· */
  static comma(control: AbstractControl): ValidationErrors | null {
    if (isEmptyInputValue(control.value)) {
      return null;
    }
    return isComma(control.value) ? null : { comma: true };
  }

  /** æ¯å¦ä¸ºæ¥æ */
  static dateline(control: AbstractControl): ValidationErrors | null {
    if (isEmptyInputValue(control.value)) {
      return null;
    }
    return control.value && isdateline(control.value)
      ? null
      : { dateline: true };
  }

  /** ç½å */
  static web(control: AbstractControl): ValidationErrors | null {
    if (isEmptyInputValue(control.value)) {
      return null;
    }
    return control.value && isWebRe(control.value) ? null : { web: true };
  }

  /** ipå°å */
  static ip(control: AbstractControl): ValidationErrors | null {
    if (isEmptyInputValue(control.value)) {
      return null;
    }
    return control.value && isIpRe(control.value) ? null : { ip: true };
  }
}

/** angularèªå¸¦çéªè¯è§å çä¸äºæ¹æ³ä¾èµ */
function isPresent(o: any): boolean {
  return o != null;
}

export function toObservable(r: any): Observable<any> {
  const obs = isPromise(r) ? from(r) : r;
  if (!isObservable(obs)) {
    throw new Error(`Expected validator to return Promise or Observable.`);
  }
  return obs;
}

function _executeValidators(
  control: AbstractControl,
  validators: ValidatorFn[]
): any[] {
  return validators.map(v => v(control));
}

function _executeAsyncValidators(
  control: AbstractControl,
  validators: AsyncValidatorFn[]
): any[] {
  return validators.map(v => v(control));
}

function _mergeErrors(
  arrayOfErrors: ValidationErrors[]
): ValidationErrors | null {
  const res: {
    [key: string]: any;
  } = arrayOfErrors.reduce(
    (resp: ValidationErrors | null, errors: ValidationErrors | null) => {
      return errors != null ? { ...resp!, ...errors } : resp!;
    },
    {}
  );
  return Object.keys(res).length === 0 ? null : res;
}
